module.exports = __webpack_public_path__ + "static/img/loading.d7d16405.png";